const updateAdmins = (state, action) => {
  if (state === undefined) {
    return {
      admins: [],
      adminsLoading: true,
      errorMessage: null,
      invoiceBasePrice: null,
      invoicePriceLoading: false,
      invoicePriceUpdating: false,
      // trainer base price
      trainerBasePrice: null,
      trainerPriceLoading: false,
      trainerPriceUpdating: false,
    };
  }

  switch (action.type) {
      //start trainer
      case 'TRAINER_BASE_PRICE_UPDATING':
          return {
              ...state.admin,
              trainerPriceUpdating: action.payload
          }
      case 'TRAINER_BASE_PRICE_LOADING':
          return {
              ...state.admin,
              trainerPriceLoading: action.payload
          }
      case 'TRAINER_BASE_PRICE_REQUESTED':
          return {
              ...state.admin,
              trainerBasePrice: action.payload
          }
      // end trainer
      case 'BASE_PRICE_UPDATING':
          return {
              ...state.admin,
              invoicePriceUpdating: action.payload
          }
      case 'BASE_PRICE_LOADING':
          return {
              ...state.admin,
                invoicePriceLoading: action.payload
          }
      case 'BASE_PRICE_REQUESTED':
          return {
              ...state.admin,
              invoiceBasePrice: action.payload
          }
    case "ADMINS_REQUESTED":
      return {
        ...state.admin,
        adminsLoading: true
      };
    case "ADMINS_LOADED":
      return {
        ...state.admin,
        adminsLoading: false,
        admins: action.payload
      };
    case "ADMINS_ERROR":
      return {
        ...state.admin,
        admins: [],
        adminsLoading: false,
        error: action.payload
      };
    case "MESSAGE_ERROR":
      return {
        ...state.admin,
        errorMessage: action.payload
      };

    default:
      return state.admin;
  }
};

export default updateAdmins;
